import { render } from "./SelectBookBlock.vue?vue&type=template&id=97be2e9a&scoped=true"
import script from "./SelectBookBlock.vue?vue&type=script&lang=js"
export * from "./SelectBookBlock.vue?vue&type=script&lang=js"

import "./SelectBookBlock.vue?vue&type=style&index=0&id=97be2e9a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-97be2e9a"

export default script